var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBombis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.89 161.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{stroke:#009640;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.57,212.9c4.53-21.35,1.22-41.17-13.27-55.73l1-11.55-12.57,1.76c-1-.61-2-1.18-3.09-1.72-24.35-12.49-40-14.91-49.32-16.07l-9.69-8.8-9.5,9c-9.33,1.37-24.89,4.13-49,17.14-1.05.57-2.07,1.16-3.06,1.78l-12.61-1.48,1.26,11.53c-14.24,14.93-17.08,35-12,56.29l-11.74,10.48,14.8,4.56c4.85,12.64,13.1,21.46,24.7,30.31q1.23.93,2.46,1.8l-.53,13.07L157,269.78a99.59,99.59,0,0,0,43.34,9.4h0a99.65,99.65,0,0,0,43.1-10.34l13.66,5.2L256.31,261c.82-.59,1.62-1.21,2.42-1.85,11.38-9.08,19.44-18,24-30.78L298,223.41Z",
    transform: "translate(-100.55 -119.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M268.46,200c-.66,20.6-16.87,49.52-35.62,56.19-17.44,6.21-31,2.26-33.14,2.2h0c-2.11.1-13.75.83-31.31-5-18.89-6.27-36-31.34-37.11-51.92s19.27-40.94,41.31-42.36a461.91,461.91,0,0,1,53.66-.58C248.32,159.46,269.12,179.38,268.46,200Z",
    transform: "translate(-100.55 -119.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197.79,190.74s-4.42-14.51-17.89-21.86-23.39-5.37-23.39-5.37-24.27,8.82-25.27,36.63C131.24,200.14,173.22,189.54,197.79,190.74Z",
    transform: "translate(-100.55 -119.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M201.74,190.7s4.11-14.6,17.41-22.25,23.27-5.87,23.27-5.87,24.46,8.3,26.05,36.07C268.47,198.65,226.28,189,201.74,190.7Z",
    transform: "translate(-100.55 -119.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197.79,190.74c-9.31-.45-21.12.78-32.19,2.5h0a14.75,14.75,0,0,1-3.2-13.26c1.81-8.29,6.4-12.93,11.4-13.94a49.49,49.49,0,0,1,6.11,2.84C193.36,176.23,197.79,190.74,197.79,190.74Z",
    transform: "translate(-100.55 -119.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M201.74,190.7c9.3-.66,21.13.32,32.23,1.8h0a14.77,14.77,0,0,0,2.92-13.32c-2-8.25-6.69-12.8-11.71-13.7a50,50,0,0,0-6,3C205.85,176.1,201.74,190.7,201.74,190.7Z",
    transform: "translate(-100.55 -119.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M268.48,199.35c-.21,36-27,64.3-67.83,64.75-36.93.4-68.81-28-69.41-64l1.61-.41c18.55-8.71,64.26-9,67-9,4-.1,50-.21,68.62,7.82A4.06,4.06,0,0,1,268.48,199.35Z",
    transform: "translate(-100.55 -119.29)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "78.29 141.62 77.9 105.87 77.54 72.23 77.53 72.67"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "121.74 141.68 121.35 105.41 120.99 72.88 120.98 72.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.88,
    y1: 106.66,
    x2: 36.59,
    y2: 79.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 161.92,
    y1: 107.73,
    x2: 161.61,
    y2: 78.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M140.48,231.5a248.34,248.34,0,0,1,38-6.34c6.67-.62,13.95-1,21.67-1.13s15.06.19,21.77.66a246.89,246.89,0,0,1,38.89,5.69",
    transform: "translate(-100.55 -119.29)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBombis);
export default __webpack_public_path__ + "static/media/bombis.8cab9639a43b1cc7c9322d520d65f37a.svg";
export { ForwardRef as ReactComponent };